module.exports = __webpack_public_path__ + "images/category_lp/tablet/store_images/5_60ce1deeb0e0c09f58c583741302eecd.png";